/* eslint-disable */
import { resolveQuery } from './query';

function trim(input) {
  return input.replace(/(^\s*|\s*$)/g, '');
}

function url() {
  let ret = resolveQuery(window.location.href);
  // eslint-disable-next-line one-var
  let from = ret.from;
  return {
    webapp: from && from.endsWith('webapp') && !isMiniprogram().miniprogram
  };
}

function ua() {
  let regs = {
    // 系统
    // 'ios': /iphone|ipad|ipod/i,
    android: /android/i,

    // 机型
    iphone: /iphone/i,
    ipad: /ipad/i,
    ipod: /ipod/i,

    // 环境
    weixin: /micromessenger/i,
    mqq: /QQ\//i,
    app: /didi\.passenger/i,
    enterpriseApp: /didies/i,
    uber: /didi\.lite\/([\d.]+)/i,
    sdk: /didi\.sdk/i,
    alipay: /aliapp/i,
    mini: /didi\.mini/i,
    quickApp: /com\.didi\.quick\.passenger/i,
    fusion: /fusionkit/i,
    kflower: /kflower/i,
    kflowerPassenger: /kflower\.passenger/i,
    didies: /didies.*?\/([\d.]+)/i,

    // 浏览器
    chrome: /chrome\//i
  };

  let ret = {};
  let ua = window.navigator.userAgent;

  for (let key in regs) {
    // eslint-disable-next-line no-prototype-builtins
    if (regs.hasOwnProperty(key)) {
      ret[key] = regs[key].test(ua);
    }
  }

  ret.ios = ret.iphone || ret.ipad || ret.ipod;

  ret.mobile = ret.ios || ret.android;
  ret.pc = !ret.mobile;

  if (window.chrome && window.chrome) {
    ret.chrome = true;
  }

  // 乘客端和企业级的ua不同
  ret.native = ret.app || ret.enterpriseApp;

  return ret;
}

function isMiniprogramByQuery() {
  let { from } = resolveQuery(window.location.href);
  return from === 'xwebapp';
}

function isWxMiniprogram() {
  let reg = /miniprogram/i;
  let UA = window.navigator.userAgent;
  let isMiniProgram = isMiniprogramByQuery();
  let isWXMini = reg.test(UA.toLowerCase());

  // 二次判断 Mini
  if (reg.test(UA.toLowerCase())) {
    isMiniProgram = true;
  } else {
    isMiniProgram = false;
  }

  if (window.__wxjs_environment === 'miniprogram') {
    isWXMini = true;
  } else {
    isWXMini = false;
  }

  return isMiniProgram && isWXMini;
}

function isAliMiniprogram() {
  let reg = /AlipayClient/i;
  let reg1 = /MiniProgram/i;
  let reg2 = /Webview/i;
  let ua = window.navigator.userAgent;
  let isMiniProgram = isMiniprogramByQuery();
  let isAliMini = false;

  if (reg.test(ua) && (reg1.test(ua) || reg2.test(ua))) {
    isAliMini = true;
  }

  return isAliMini;
}

function isMiniprogram() {
  return {
    miniprogram: isAliMiniprogram() || isWxMiniprogram()
  };
}

function runtime(strs) {
  let str = strs.split(',');
  let uaRet = ua();
  let urlRet = url();
  let miniRet = isMiniprogram();
  let result = Object.assign({}, uaRet, urlRet, miniRet);

  // 根据链式表达式检查UA
  let check = rote => {
    rote = trim(rote) || '';
    if (!rote) {
      return false;
    }
    // 按照点.分割
    let rotes = rote.split('.');
    let ret = true;
    rotes.forEach(r => {
      if (!result[r]) {
        ret = false;
      }
    });
    return ret;
  };

  let ret = false;
  str.forEach(s => {
    if (check(s)) {
      ret = true;
    }
  });
  return ret;
}

let is = (runtime.is = runtime);

export { runtime, is, isAliMiniprogram, isWxMiniprogram };
